import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="text-center py-16">
        <div className="mx-auto max-w-md">
          <div className="mx-auto h-24 w-24 bg-gray-100 rounded-full flex items-center justify-center">
            <span className="text-4xl font-bold text-gray-400">404</span>
          </div>
          <h1 className="mt-6 text-3xl font-bold text-gray-900">
            Page non trouvée
          </h1>
          <p className="mt-4 text-base text-gray-600">
            Désolé, nous n'avons pas pu trouver la page que vous recherchez.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="btn-primary"
            >
              <Home className="h-4 w-4 mr-2" />
              Retour à l'accueil
            </Link>
            <button
              onClick={() => window.history.back()}
              className="btn-secondary"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Retour en arrière
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 